import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecuritySchemesAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-schemes-add',
	path: '/secure/admin/AddIssueSecurityScheme([!%]?[\\w]*).jspa',
};
